var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"flex flex-col px-4"},[_c('h4',{staticClass:"font-bold text-grey-darkest text-4xl",domProps:{"textContent":_vm._s(`Total: ${_vm.baseTotal}`)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }